// extracted by mini-css-extract-plugin
export default {"home_container":"home_home_container__TiKpf","title_container":"home_title_container__lGXAW","main_title":"home_main_title__RUV7d"};